module.exports = __webpack_public_path__ + "img/static-brand3@2x.4b0bf7c0.png";